const lineSpacingModals = {
  customSpacing: `lineSpacing.customSpacing`
};
export {
  lineSpacingModals
};
//# sourceMappingURL=consts.js.map
